import TopWriters from '@front/blocks/dist/top-writers';

import { _on } from '../../utils';
import renderer from '../../utils/renderer';

renderer('[data-top-writers]', TopWriters);

const SCROLL_POS_KEY = 'scrollpos';

// Saving scroll position to avoid page jumps on filters (used locally as it's not needed anywhere else) SHARK-3002
document.addEventListener('DOMContentLoaded', function () {
  // Check if previous page was our-writers
  if (document.referrer.includes('our-writers')) {
    const scrollpos = localStorage.getItem(SCROLL_POS_KEY);
    if (scrollpos) window.scrollTo(0, Number(scrollpos));
    localStorage.removeItem(SCROLL_POS_KEY);
  } else {
    localStorage.setItem(SCROLL_POS_KEY, '0');
  }
});
_on('click', 'js--scroll-pos', function () {
  localStorage.setItem(SCROLL_POS_KEY, '0');
});

window.onbeforeunload = function () {
  if (!localStorage.getItem(SCROLL_POS_KEY)) {
    localStorage.setItem(SCROLL_POS_KEY, JSON.stringify(window.scrollY));
  }
};
